import { render, staticRenderFns } from "./AddRoleDialog.vue?vue&type=template&id=3e80658d&scoped=true"
import script from "./AddRoleDialog.vue?vue&type=script&lang=js"
export * from "./AddRoleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e80658d",
  null
  
)

export default component.exports